import { Link } from "react-router-dom";
import classes from "./OgxPrograms.module.css";
import globalVolunteerLogo from "../../Assets/Images/gv2.svg";
import globalTalentLogo from "../../Assets/Images/globalTalent.svg";
import globalTeacherLogo from "../../Assets/Images/globalTeacher.svg";
import globalVolunteerImg from "../../Assets/Images/ogx-volunteer.png";
import globalTalentImg from "../../Assets/Images/ogx-talent.png";
import globalTeacherImg from "../../Assets/Images/ogx-teacher.png";

const OgxPrograms = () => {
  const programs = [
    {
      title: "Global Volunteer",
      image: globalVolunteerImg,
      logo: globalVolunteerLogo,
      weeks: "6-8 Weeks",
      caption: "Short-term volunteering on a social project. Open to students.",
      description:
        "Global Volunteer gives you the opportunity to step out of Nigeria and lead change on a global scale by connecting you to vetted social impact projects abroad. You get to join a social impact project, work alongside people from different backgrounds, and address real community needs, from education and sustainability to inclusion and youth development. Along the way, you'll develop leadership, teamwork, communication, and problem-solving skills while experiencing a new culture, build a global network, and create an impact you can bring back to Nigeria.",
      url: "https://aiesec.org/global-volunteer",
    },
    {
      title: "Global Talent",
      image: globalTalentImg,
      logo: globalTalentLogo,
      weeks: "6+ Weeks",
      caption: "Paid professional internship abroad. Graduates only.",
      description:
        "Global Talent is an international work experience designed for young Nigerians ready to take their career beyond borders. Through AIESEC in Nigeria, graduates, NYSC members, and early-career professionals access paid internships in leading global companies and startups. You'll work in high-growth fields like tech, business, and marketing, build practical cross-border competence, and return with a globally competitive profile that sets you apart at home.",
      url: "https://aiesec.org/global-talent",
    },
    {
      title: "Global Teacher",
      image: globalTeacherImg,
      logo: globalTeacherLogo,
      weeks: "6+ Weeks",
      caption: "Teaching placement in a classroom abroad. Graduates only.",
      description:
        "Global Teacher is an international teaching experience for young people who want to share their knowledge and get paid while doing that. Through AIESEC in Nigeria, Global Teacher offers young Nigerian educators and graduates paid placements in schools abroad. This experience gives you the opportunity to inspire others, grow professionally, and see the world from a completely different perspective.",
      url: "https://aiesec.org/global-teacher",
    },
  ];

  return (
    <section className={classes.container} id="ogx-programs">
      <div className={classes.header}>
        <p className={classes.eyebrow}>Gain a competitive edge</p>
        <h2>Work &amp; Volunteer Abroad</h2>
        <p className={classes.subtitle}>
          AIESEC in Nigeria connects students and graduates to international
          internships and cross-cultural volunteering opportunities.
        </p>
      </div>

      <div className={classes.rows}>
        {programs.map((program, i) => (
          <div
            className={`${classes.row} ${i % 2 === 1 ? classes.reverse : ""}`}
            key={i}
          >
            <div className={classes.imageCol}>
              <div className={classes.photo}>
                <img src={program.image} alt={program.title} loading="lazy" />
                <div className={classes.badge}>
                  <img
                    src={program.logo}
                    alt={`${program.title} logo`}
                    loading="lazy"
                  />
                </div>
                <div className={classes.caption}>
                  <span className={classes.weeks}>{program.weeks}</span>
                  <span className={classes.captionText}>{program.caption}</span>
                </div>
              </div>
            </div>

            <div className={classes.textCol}>
              <h3 className={classes.title}>{program.title}</h3>
              <p className={classes.desc}>{program.description}</p>
              <div className={classes.applyWrap}>
                <Link className={classes.apply} to="/ogx/apply">
                  Apply Now
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      opacity="0.7"
                      d="M1.5 10.5L11 1M11 1H4.18868M11 1V7.63208"
                      stroke="#037EF3"
                      strokeWidth="1.43396"
                    />
                  </svg>
                </Link>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="125"
                  height="9"
                  viewBox="0 0 125 9"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M1 7.94615C29.5101 7.94615 57.8234 2.32561 86.4499 2.11512C98.3222 2.02783 110.086 1.95706 121.94 2.11512C125.151 2.15794 125.009 1.52784 121.796 1.46722C116.092 1.3596 110.85 0.378442 105.023 0.675354C94.2642 1.22357 83.4704 0.831205 72.7001 1.32324C50.7367 2.32664 28.7512 1.95116 6.83105 2.76301"
                    stroke="#037EF3"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OgxPrograms;
